<template>
  <div class="body-right">
    <div class="title-body-right">
      <h1
        class="title-page pointer"
        @click="backtoCategory()"
        v-if="categoryDetail"
      >
        <i class="el-icon-arrow-left icon" />
        {{ categoryDetail.name }}
      </h1>

      <div class="group-btn">
        <el-button class="btn" type="primary" @click="handleOpenAddDialog()">
          {{ $t('category.addCategoryBtn') }}
        </el-button>

        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>
      </div>
    </div>

    <div class="search-wrap">
      <div class="search-form" :class="openSearchForm ? 'open' : 'hidden'">
        <el-form
          :inline="true"
          :model="search"
          class="form"
          @submit.native.prevent
          @keyup.enter.native="onSubmitSearch()"
        >
          <el-form-item>
            <el-input
              v-model="search.name"
              :placeholder="$t('category.placeholderName')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.name = ''"
                v-if="search.name"
              ></i
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search-button"
              type="primary"
              @click="onSubmitSearch"
            >
              {{ $t('category.searchBtn') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-row
        class="total-table"
        :class="openSearchForm ? 'total-table-absolute' : ''"
      >
        {{ $t('category.total') }}: {{ subcategory.total }}
      </el-row>
    </div>

    <table-subcategory
      :dataColumn="subcategory.data"
      :currentPage="subcategory.currentPage"
    />

    <div class="pagination">
      <base-pagination
        :totalPage="subcategory.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      ></base-pagination>
    </div>

    <add-subcategory-dialog
      :openAddDialog="openAddDialog"
      :categoryId="categoryId"
      @handleCloseAddDialog="handleCloseAddDialog()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import pageRouter from '@/constants/pageRouter';

const BasePagination = () => import('@/components/BasePagination');
const AddSubcategoryDialog = () => import('./AddSubcategoryDialog');
const TableSubcategory = () => import('./TableListSubcategory');

export default {
  name: 'ListSubcategory',
  components: {
    BasePagination,
    AddSubcategoryDialog,
    TableSubcategory,
  },
  data() {
    return {
      openAddDialog: false,
      formLabelWidth: '120px',
      categoryId: null,
      openSearchForm: true,
      search: {
        name: undefined,
        page: PAGE,
        limit: LIMIT,
      },
    };
  },
  computed: {
    ...mapGetters('subcategory', ['subcategory']),
    ...mapGetters('category', ['categoryDetail']),
  },
  methods: {
    ...mapActions('subcategory', ['getSubcategoryList']),
    ...mapActions('category', ['getCategoryDetail']),
    handleOpenAddDialog() {
      this.openAddDialog = true;
    },
    handleCloseAddDialog() {
      this.openAddDialog = false;
    },
    onSubmitSearch() {
      this.search = {
        ...this.search,
        name: this.search.name ? this.search.name.trim() : undefined,
        page: PAGE,
      };

      this.getSubcategoryList({
        categoryId: this.categoryId,
        params: this.search,
      });

      redirectRouter({
        path: this.$router.currentRoute.fullPath,
        query: {
          name: this.search.name ? this.search.name.trim() : undefined,
          page: this.search.page,
        },
      });
    },
    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        page: e.page,
        limit: LIMIT,
      };

      this.getSubcategoryList({
        categoryId: this.categoryId,
        params: this.search,
      });

      redirectRouter({
        path: `/categories/${this.categoryId}/sub-categories`,
        query: {
          ...this.$router.currentRoute.query,
          page: this.search.page || undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
    backtoCategory() {
      redirectRouter({
        path: pageRouter.CATEGORY,
        query: {
          name: this.$route.query.name,
        },
      });
    },
  },
  created() {
    this.categoryId = this.$router.currentRoute.params.id;

    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
    };
    this.getSubcategoryList({
      categoryId: this.categoryId,
      params: this.search,
    });
    this.getCategoryDetail({ categoryId: this.categoryId });
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
@import './styles.module.scss';
</style>
